import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Badge = ({ id, children, icon, type, srText, text }) => {
  const typeClasses = classNames({
    'ids-badge': true,
    [`ids-badge--${type}`]: type,
  });

  const iconClasses = classNames({
    'ids-badge__icon': icon,
    [`ids-badge__icon--${type}`]: type,
  });

  return (
    <div className={typeClasses}>
      {icon && <i className={iconClasses} aria-hidden />}
      {children}

      <span id={id} className="show-for-sr">
        {srText ?? text}
      </span>

      <span aria-hidden>{text}</span>
    </div>
  );
};

Badge.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.bool,
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'neutral',
    'success',
    'info',
    'attention',
    'error',
  ]),
  srText: PropTypes.string,
  text: PropTypes.string,
};

export default Badge;
